import { ActivityLogSearchCriteria } from 'src/app/modules/stp-operations/models/activity-log-search-criteria';

export class StpRegistrationActivityLogSearchCriteria extends ActivityLogSearchCriteria {
  // full STP name, matched exactly (case-insensitive) by the backend; null = all
  public stpName: string | null = null;
  // exact match on one of the application status values; null = all
  public applicationStatus: string | null = null;
  // 'STP User', 'NSDA User' or 'System'; null = all
  public actorType: string | null = null;

  constructor() {
    super();
  }
}
